export enum CalendarView {
  WallPlanner = "wallPlanner",
  BookingsOnly = "bookingsOnly",
  Bookings = "bookings",
  Compressed = "compressed",
  Grid = "grid"
}

export enum CalendarMetric {
  Utilization = "utilization",
  Availability = "availability",
  TotalHours = "totalHours"
}
